import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ViewChild,
  Injector,
} from '@angular/core';
import { Observable } from 'rxjs';

// tslint:disable-next-line:max-line-length
import { BitfFileUploaderComponent } from '@bitf/core/components/ui/file-uploader/bitf-file-uploader.component';

import { StoreService, FsService } from '@services';
import { FsItem, Tag, BitfOption, BitfFormItem, FsStore } from '@models';
import { IBitfApiResponse, IBitfApiRequest, IFileUploaderConfig } from '@interfaces';
import { EFsContentType, ERoleActions, ERoleMode, EFsType } from '@enums';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'prada-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploaderComponent extends BitfFileUploaderComponent<FsItem> implements OnInit {
  @Input()
  config: IFileUploaderConfig = {
    isScrollable: false,
  };
  @Input() tagsFormItemsConfig: BitfFormItem;
  @Input() fsStore: FsStore;
  @Input() uploadFor: FsItem;
  @Output() isUploadingEvent: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('selectFile') selectFileInput;

  form: FormGroup;
  fileTags: { tags: BitfOption[]; useParentTag: boolean }[] = [];
  parentTags: BitfOption[] = [];
  useParentTags = false;
  overrideFile = false;
  fileThatUseParentTags = 0;
  isUploading = false;
  isUploadConfirmed = true;

  ERoleActions = ERoleActions;
  ERoleMode = ERoleMode;
  EFsType = EFsType;
  constructor(
    private fsService: FsService,
    public storeService: StoreService,
    private formBuilder: FormBuilder,
    public injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();

    this.initForm();

    // NOTE this is managed via two way data binding
    this.isUploadConfirmed = this.fsStore.configuration.isUploadConfirmed;
  }

  onFileDropped(event: FileList | any) {
    super.onFileDropped(event);
    this.selectFileInput.nativeElement.value = '';
  }

  upload() {
    const body = this.buildUploadBodyRequest();
    super.upload();
    this.setUploadingStatus(true);
    let uploader: Observable<IBitfApiResponse<FsItem[]>[]>;
    const apiRequest: IBitfApiRequest = {
      id: this.fsStore.currentItem.id,
      files: this.uploadableFiles.map(file => {
        if (file.metaData._tags && file.metaData._tags.length > 0) {
          file.bodyData.tags = JSON.stringify(
            file.metaData._tags.map(tag => new Tag({ id: tag.id as any, title: tag.label }).serialised)
          );
        } else if (file.metaData.useParentTag) {
          file.bodyData.tags = JSON.stringify(
            this.parentTags.map(tag => new Tag({ id: tag.id as any, title: tag.label }).serialised)
          );
        }
        return file;
      }),
      fileFormFieldName: 'file',
      body,
      isBodyRaw: true,
    };
    uploader = this.fsService.useFs(this.fsStore).uploadMultiple<FsItem[]>(apiRequest);
    this.subscribeToMultipleFileUpload(uploader);
  }

  subscribeToMultipleFileUpload(uploader) {
    uploader.subscribe((responses: IBitfApiResponse<FsItem>[]) => {
      this.setUploadingStatus(false);
      this.removeUploadedFiles();
      this.filesUploaded.emit(responses.map(r => r.content));
    });
  }

  onParentTagToggleChange(event: MatCheckboxChange) {
    this.files.forEach(value => {
      value.metaData.useParentTag = event.checked;
    });
    this.updateFileThatUseParentTags();
  }

  onFileTagsChange(event: MatCheckboxChange) {
    this.updateFileThatUseParentTags();
  }

  removeFile(index: number) {
    super.removeFile(index);

    this.updateFileThatUseParentTags();
  }

  private setUploadingStatus(status: boolean) {
    this.isUploading = status;
    this.isUploadingEvent.emit(status);
  }

  private updateFileThatUseParentTags() {
    this.fileThatUseParentTags = this.files.filter(val => val.metaData.useParentTag).length;
    this.useParentTags = this.fileThatUseParentTags > 0;
  }

  private initForm() {
    this.form = this.formBuilder.group({
      tags: null,
    });

    this.form.get('tags').valueChanges.subscribe(value => {
      this.parentTags = value;
    });
  }

  // Manage custom request from file-uploader
  private buildUploadBodyRequest() {
    const canOverride = this.fsStore.configuration.uploadBodyRequest.canOverride;
    return {
      ...this.fsStore.configuration.uploadBodyRequest,
      overrideFile: canOverride && this.overrideFile,
    };
  }
}
